import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { DateTime } from 'luxon';

export class AdapterLuxonWrapper extends AdapterLuxon {
  // The one in AdapterLuxon is private and so we can't re-use it.
  setLocaleToValue2 = (value) => {
    const expectedLocale = this.getCurrentLocaleCode();
    if (expectedLocale === value.locale) {
      return value;
    }

    return value.setLocale(expectedLocale);
  };

  /**
   * Force Sunday as the start of the week, regardless of locale.
   * Luxon weekday: Mon=1 ... Sun=7, so Sunday % 7 => 0.
   */
  startOfWeek = (value) => {
    const d = this.setLocaleToValue2(value);
    const daysSinceSunday = d.weekday % 7; // Sun->0, Mon->1, ... Sat->6
    return d.minus({ days: daysSinceSunday }).startOf('day');
  };

  endOfWeek = (value) => this.startOfWeek(value).plus({ days: 6 }).endOf('day');

  /**
   * Build the month grid using our Sunday-based week boundaries.
   * (Inclusive day count to avoid off-by-one)
   */
  getWeekArray = (value) => {
    const clean = this.setLocaleToValue2(value);
    const firstDay = this.startOfWeek(this.startOfMonth(clean));
    const lastDay = this.endOfWeek(this.endOfMonth(clean));

    // inclusive number of days between firstDay and lastDay
    const totalDays = Math.floor(lastDay.startOf('day').diff(firstDay.startOf('day'), 'days').days) + 1;

    const weeks = [];
    for (let i = 0; i < totalDays; i++) {
      const v = firstDay.plus({ days: i });
      if (i === 0 || i % 7 === 0) weeks.push([v]);
      else weeks[weeks.length - 1].push(v);
    }
    return weeks;
  };

  /**
   * Make week numbers align with Sunday-start weeks:
   * Week 1 begins on the Sunday that contains Jan 1.
   */
  getWeekNumber = (value) => {
    const d = this.setLocaleToValue2(value).startOf('day');
    const yearStart = DateTime.fromObject({
      year: d.year,
      month: 1,
      day: 1,
      zone: d.zoneName,
      locale: d.locale,
    });
    const firstWeekStart = this.startOfWeek(yearStart);
    const daysFromFirst = Math.floor(d.diff(firstWeekStart, 'days').days);
    return Math.floor(daysFromFirst / 7) + 1;
  };
}
